module.exports = __webpack_public_path__ + "static/media/outStock.e0436a65.svg";